import React from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import * as S from "./style";
import { FiYoutube, FiInstagram, FiMessageCircle } from "react-icons/fi";
import FamilySite from "components/FamilySite";

function FooterMain() {
  const history = useHistory();
  const { dataCategoriesTerm } = useSelector(
    (state: any) => state.dataCategoriesTerm
  );

  return (
    <S.Wrapper id="footer">
      <S.Container>
        <S.CollapseWrapper>
          <S.InfoBlock>
            <S.InfoRow>
              <span className="strong">(주)열매컴퍼니</span>
              <S.Pipe>|</S.Pipe>
              <span>
                <span className="key">대표자:</span> 김재욱
              </span>
              <S.Pipe>|</S.Pipe>
              <span>
                <span className="key">사업자등록번호:</span> 664-88-00573
              </span>
              <S.Pipe>|</S.Pipe>
              <span>
                <span className="key">통신판매업신고:</span> 2021-충남아산-0558호
              </span>
              <S.Pipe>|</S.Pipe>
              <span>
                <span className="key">개인정보보호책임자:</span> 김재욱
              </span>
            </S.InfoRow>

            <S.InfoRow>
              <span>충남 아산시 배방읍 희망로 46번길 45-11, 405호</span>
              <S.Pipe>|</S.Pipe>
              <span>서울 성동구 왕십리로 58, 312호</span>
            </S.InfoRow>

            <S.InfoRow>
              <span className="strong">070-5015-0772, 0773</span>
              <S.Pipe>|</S.Pipe>
              <span>cs@artnguide.com</span>
              <S.Pipe>|</S.Pipe>
              <span className="sub">
                평일 운영 (점심시간 13:00 ~ 14:00) 주말/공휴일 휴무
              </span>
            </S.InfoRow>
          </S.InfoBlock>
        </S.CollapseWrapper>

        <S.Divider />

        <S.ContainerTerm>
          <S.BottomBar>
            <S.TermsList>
              {dataCategoriesTerm?.map((dt: any, i: any) => (
                <S.TermItem key={i} onClick={() => history.push(dt.location)}>
                  {dt.title}
                </S.TermItem>
              ))}
            </S.TermsList>

            <S.BottomRight>
              <S.SnsRow>
                <S.SnsButton
                  type="button"
                  aria-label="youtube"
                  onClick={() =>
                    window.open("https://www.youtube.com/@Artnguide", "_blank")
                  }
                >
                  <FiYoutube />
                </S.SnsButton>
                <S.SnsButton
                  type="button"
                  aria-label="instagram"
                  onClick={() =>
                    window.open(
                      "https://www.instagram.com/artnguide?igsh=YXM1Mjdhb20wMng2",
                      "_blank"
                    )
                  }
                >
                  <FiInstagram />
                </S.SnsButton>
                <S.SnsButton
                  type="button"
                  aria-label="kakaoplus"
                  onClick={() =>
                    window.open("https://pf.kakao.com/_ixgPNj", "_blank")
                  }
                >
                  <FiMessageCircle />
                </S.SnsButton>
              </S.SnsRow>
              <FamilySite />
            </S.BottomRight>
          </S.BottomBar>

          <S.TextMin>© Yeolmaecompany. all rights reserved</S.TextMin>
        </S.ContainerTerm>
      </S.Container>
    </S.Wrapper>
  );
}
export default FooterMain;
